module.exports = __webpack_public_path__ + "public/img/bg-sertif-participant.adabb77d.jpg";